var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.1429 10H42.5893C43.2589 9.64286 43.8281 9.87723 44.2969 10.346C44.7656 10.8147 45 11.3839 45 12.0536V42.5893C45 43.2589 44.7656 43.8281 44.2969 44.2969C43.8281 44.7656 43.2589 45 42.5893 45H18.4821C17.8125 45 17.2433 44.7656 16.7746 44.2969C16.3058 43.8281 16.0714 43.2589 16.0714 42.5893V35H2.41071C1.74107 35.3571 1.17188 35.1228 0.703125 34.654C0.234375 34.1853 0 33.6161 0 32.9464V16.0714C0 15.4018 0.167411 14.6652 0.502232 13.8616C0.837054 13.058 1.23884 12.4219 1.70759 11.9531L11.9531 1.70759C12.4219 1.23884 13.058 0.837054 13.8616 0.502232C14.6652 0.167411 15.4018 0 16.0714 0H26.5179C27.1875 0 27.7567 0.234375 28.2254 0.703125C28.6942 1.17188 28.9286 1.74107 28.9286 2.41071V10.6473C30.067 9.97768 31.1384 9.64286 32.1429 10ZM28.9286 22.5V14.9916L21.4202 22.5H28.9286ZM12.8571 12.8571V5.34877L5.34877 12.8571H12.8571ZM16.5737 23.5045C16.9085 22.7009 17.3103 22.0647 17.779 21.596L25 13.6607V3.21429H16V13.6607C16.0714 14.3304 15.8371 14.8996 15.3683 15.3683C14.8996 15.8371 14.3304 16.0714 13.6607 16H4V32H16.0714V25.7143C16.0714 25.0446 16.2388 24.308 16.5737 23.5045ZM20 41H41V12.8571H32V23.3036C32.1429 23.9732 31.9085 24.5424 31.4397 25.0112C30.971 25.4799 30.4018 25.7143 29.7321 25H20V41Z",
    fill: "#05164D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocs);
export default __webpack_public_path__ + "static/media/docs.94140be9c98ed9628b91bbfc2b79a269.svg";
export { ForwardRef as ReactComponent };